module.exports = __webpack_public_path__ + "static/img/mechanism-5.37924df6.png";